import { render, staticRenderFns } from "./daoru.vue?vue&type=template&id=4bea9890&scoped=true&"
import script from "./daoru.vue?vue&type=script&lang=js&"
export * from "./daoru.vue?vue&type=script&lang=js&"
import style0 from "./daoru.vue?vue&type=style&index=0&id=4bea9890&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bea9890",
  null
  
)

export default component.exports